import { guardianStatusLabel } from '../Enrollments/inviteWords';

export interface GuardianInviteRow {
  name: string;
  email?: string | null;
  status?: string | null;
  expiresAt?: string | null;
}

/** Each guardian of a family year with where they stand with the invitation, in words. */
export function GuardianInviteStatus({ guardians }: { guardians: GuardianInviteRow[] }) {
  if (guardians.length === 0) return null;
  return (
    <div className="space-y-2">
      <h4 className="font-semibold text-sm">Guardians</h4>
      <ul className="divide-y rounded-md border">
        {guardians.map((guardian, index) => (
          <li key={`${index}-${guardian.name}`} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 px-3 py-2 text-sm">
            <span className="min-w-0 break-words">
              {guardian.name}
              {guardian.email && <span className="ml-2 text-muted-foreground">{guardian.email}</span>}
            </span>
            <span className="text-muted-foreground">{guardianStatusLabel(guardian.status, guardian.expiresAt)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default GuardianInviteStatus;
